import API from "./api";

// ✅ GET COURSES
export const getCourses = async (params) => {
  const school = JSON.parse(localStorage.getItem("schoolAdmin"));

  return API.get("/school-admin/courses/", {
    params,
    headers: {
      "X-SCHOOL-ID": school.school.id,
    },
  });
};

// ✅ GET CLASSES (already working like AddSection)
export const getClasses = async () => {
  const school = JSON.parse(localStorage.getItem("schoolAdmin"));

  return API.get("/school-admin/classes/", {
    headers: {
      "X-SCHOOL-ID": school.school.id,
    },
  });
};

// ✅ CREATE COURSE (🔥 FIXED)
export const createCourse = async (data) => {
  const school = JSON.parse(localStorage.getItem("schoolAdmin"));

  return API.post("/school-admin/courses/add/", data, {
    headers: {
      "X-SCHOOL-ID": school.school.id,
    },
  });
};

// ✅ UPDATE COURSE
export const updateCourse = async (id, data) => {
  const school = JSON.parse(localStorage.getItem("schoolAdmin"));

  return API.put(`/school-admin/courses/update/${id}/`, data, {
    headers: {
      "X-SCHOOL-ID": school.school.id,
    },
  });
};

// ✅ DELETE COURSE
export const deleteCourse = async (id) => {
  const school = JSON.parse(localStorage.getItem("schoolAdmin"));

  return API.delete(`/school-admin/courses/delete/${id}/`, {
    headers: {
      "X-SCHOOL-ID": school.school.id,
    },
  });
};